module.exports = __webpack_public_path__ + "img/score_01.8395f44a.svg";